import React from 'react';
import { Link } from 'react-router-dom';

class AboutPage extends React.Component {
  render() {
    return (
      <div className="about-page">
        <div className="about-hero">
          <img src="/logo.jpeg" alt="Zinex Softwares" className="about-logo" />
          <h1>About Zinex Softwares</h1>
          <p className="about-lead">
            We help individuals and small teams in Nigeria get genuine
            software licenses without paying full retail price.
          </p>
        </div>

        <div className="about-body">
          <section>
            <h2>How shared licensing works</h2>
            <p>
              Some software plans officially support multiple people on one
              subscription — Microsoft 365 Family, Canva Pro's Team plan,
              multi-device antivirus and VPN plans, and more. Instead of one
              buyer paying for the full plan alone, we pool a set number of
              buyers onto the same multi-seat plan and split the cost between
              them. You get full, working access to the software; you just
              aren't the only one on that plan.
            </p>
          </section>

          <section>
            <h2>Our promise</h2>
            <ul className="promise-list">
              <li>Licenses emailed the same day payment is confirmed</li>
              <li>Transparent pricing — private vs shared cost shown upfront on every product</li>
              <li>Support if activation ever fails</li>
            </ul>
          </section>

          <section className="about-cta">
            <Link to="/products" className="btn btn-primary btn-lg">Browse licenses</Link>
          </section>
        </div>
      </div>
    );
  }
}

export default AboutPage;
